import SalesService from "@/modules/sales/SalesService";

export default {
  namespaced: true,
  state: {
    batchLotUpV2Data: {
      sale: null,
      items: [],
      reservedLotNos: [],
      loading: false,
    },
    toggleColumnsModal: {
      show: false
    },
    lotEditModal: {
      show: false,
      object: null,
      maxLotNo: null
    }
  },
  actions: {
    async initBatchLotUpV2Data({state, dispatch}, saleNo) {
      state.batchLotUpV2Data.loading = true

      let response = await SalesService.saleExists(saleNo, 'currency');
      if (response.success) {
        state.batchLotUpV2Data.sale = response.body;
        await dispatch('getBatchLotUpV2Data', state.batchLotUpV2Data.sale.uuid);
      }

      state.batchLotUpV2Data.loading = false
      return response;
    },
    async getBatchLotUpV2Data({state}, auctionUuid) {
      let response = await SalesService.getBatchLotUpData(auctionUuid);
      if (response.success) {
        let results = response.body.results
        state.batchLotUpV2Data.items = results.filter(i => ['lotted', 'reserved'].includes(i.status))
        state.batchLotUpV2Data.reservedLotNos = results.filter(i => !['lotted', 'reserved'].includes(i.status)).map(i => parseInt(i.lot_no))
      }
      return response;
    },
    clearData({state}) {
      state.batchLotUpV2Data = {
        sale: null,
        items: [],
        loading: false,
      }
    },
    showToggleColumnsModal({state}) {
      state.toggleColumnsModal.show = true
    },
    hideToggleColumnsModal({state}) {
      state.toggleColumnsModal.show = false
    },
    showLotEditModal({state}, {object, maxLotNo}) {
      state.lotEditModal.object = object
      state.lotEditModal.show = true
      state.lotEditModal.maxLotNo = maxLotNo
    },
    hideLotEditModal({state}) {
      state.lotEditModal.show = false
      state.lotEditModal.object = null
      state.lotEditModal.maxLotNo = null
    }
  },
  mutations: {}
}
